import React from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Select,
  Stack,
  Textarea,
} from "@chakra-ui/react";
import { Category } from "../types";
import { RequestCreateValidationErrors } from "../validation";

type RequestDetailsSectionProps = {
  categories: Category[];
  categoryId: string;
  otherCategoryText: string;
  description: string;
  startDate: string;
  isSubmitting: boolean;
  errors?: Pick<RequestCreateValidationErrors, "category" | "startDate">;
  onCategoryChange: (categoryId: string) => void;
  onOtherCategoryTextChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onSubmit: () => void;
};

export const RequestDetailsSection = ({
  categories,
  categoryId,
  otherCategoryText,
  description,
  startDate,
  isSubmitting,
  errors,
  onCategoryChange,
  onOtherCategoryTextChange,
  onDescriptionChange,
  onStartDateChange,
  onSubmit,
}: RequestDetailsSectionProps) => (
  <Box bg="white" borderWidth="1px" borderColor="gray.200" rounded="md" p={5}>
    <Heading size="sm" mb={4}>
      Request details
    </Heading>
    <Stack spacing={4}>
      <FormControl isRequired isInvalid={Boolean(errors?.category)}>
        <FormLabel htmlFor="request-category">Category</FormLabel>
        <Select
          id="request-category"
          value={categoryId}
          onChange={(event) => onCategoryChange(event.target.value)}
          placeholder="Select a category"
          isDisabled={Boolean(otherCategoryText)}
        >
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </Select>
        <FormErrorMessage>{errors?.category}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={Boolean(errors?.category)}>
        <FormLabel htmlFor="request-other-category">Custom request type</FormLabel>
        <Input
          id="request-other-category"
          value={otherCategoryText}
          onChange={(event) => onOtherCategoryTextChange(event.target.value)}
          placeholder="Use when the category is not listed"
        />
      </FormControl>
      <FormControl isRequired isInvalid={Boolean(errors?.startDate)}>
        <FormLabel htmlFor="request-start-date">Start date</FormLabel>
        <Input
          id="request-start-date"
          type="date"
          value={startDate}
          onChange={(event) => onStartDateChange(event.target.value)}
        />
        <FormErrorMessage>{errors?.startDate}</FormErrorMessage>
      </FormControl>
      <FormControl>
        <FormLabel htmlFor="request-description">Description</FormLabel>
        <Textarea
          id="request-description"
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          placeholder="Describe what the homeowner needs"
        />
      </FormControl>
      <Flex justify="flex-end">
        <Button colorScheme="teal" onClick={onSubmit} isLoading={isSubmitting}>
          Create request
        </Button>
      </Flex>
    </Stack>
  </Box>
);
